export const NUMBER_OF_SEEDS = 4;
export const NUMBER_OF_INTER_FRAMES = 3;
export const SPACING_BETWEEN_IMAGES = 24;
export const SPACING_BETWEEN_ROWS = 24;
export const FOOTER_HEIGHT = 80;
export const ANIMATION_DURATION_SECONDS = 0.3;
export const SEED_BACKGROUND_PADDING = 8;
export const KEY_FRAME_TO_INTER_FRAME_DIMENSION = 2.5;
